import axios from "axios";
import { serverApi } from "../../../config/Keys";
import { setErrors } from "../errorActions";

export const needHelp = (formData, onSuccess) => async (dispatch) => {
  try {
    const resultApi = await axios.post(`${serverApi}/vendor/ticket`, formData);
    if (resultApi.status === 201) {
      onSuccess(resultApi.data);
    }
  } catch (err) {
    dispatch(setErrors(err));
  }
};

export const getInfoVendorByMobile = (
  number,
  country_code,
  onSuccess,
  onError
) => async (dispatch) => {
  try {
    const resultApi = await axios.get(
      `${serverApi}/vendorDetailsByMobile?mobile_number=${number}&country_code=${country_code}`
    );
    if (resultApi.status === 200) {
      onSuccess(resultApi.data);
    }
  } catch (err) {
    onError();
    // dispatch(setErrors(err));
  }
};

/***************************************
 * @DESC - GET TICKET ISSUES SUB CATEGORY ACTION
 *****************************************/
export const get_vendor_tickets_issue_category_need_help = (
  onSuccess
) => async (dispatch) => {
  try {
    let get_tickets_issue_category = await axios.get(
      `${serverApi}/subcategory?category_id=6086523d5cb5e71fd7c58d5e`
    );
    if (get_tickets_issue_category.status === 200) {
      onSuccess(get_tickets_issue_category.data);
    }
  } catch (err) {
    dispatch(setErrors(err));
  }
};
